import React, { useState, useEffect } from "react";
import { Input, Switch } from "antd";

const SearchBar = ({ search, setSearch, routerProps }) => {
  const { Search } = Input;
  const [input, setInput] = useState();

  function handleSearch(value) {
    setSearch(value);
  }

  const handleFieldChange = (evt) => {
    const value = evt.target.value;
    setInput(value);
  };

  return (
    <div className="productNavbar">
      <Search
        className="searchBar"
        onChange={handleFieldChange}
        placeholder="Search product information . . ."
        onSearch={(value) => handleSearch(value)}
        enterButton
      />
    </div>
  );
};

export default SearchBar;
